import CRUD from '../base/crud'

class AlertsCRUD extends CRUD {
  getAlerts(params) {
    return this.request({
      url: this.url,
      params,
    })
  }
  deleteAlert(id, params) {
    return this.request({
      url: `${this.url}/${id}`,
      method: 'DELETE',
      params,
    })
  }
  changeStatusAlert(id, data, params) {
    return this.request({
      url: `${this.url}/${id}`,
      method: 'PATCH',
      data,
      params,
    })
  }

  markAsReadApi() {
    return this.request({
      url: `${this.url}`,
      method: 'PATCH',
    })
  }
}

//PATCH: https://dev-api.ampenergy.io/alerts/

export default function alertsCRUD(request) {
  return new AlertsCRUD({
    url: '/alerts',
    request,
  })
}
